import React from "react";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import "./index.css";
import {
  CampaignManagerOptions,
  TerritoryOptions,
  Characters,
  stageOptions,
} from "../../Constants/brand";

const EcosystemGoIcon = require("../../assets/media/ecosystem_go.png");
const EcosystemProIcon = require("../../assets/media/ecosystem_pro.png");
const EcosystemTrialIcon = require("../../assets/media/ecosystem_trial.png");

const UK_flag = require("../../assets/media/circle-uk.png");
const US_flag = require("../../assets/media/circle-us.png");
const CA_flag = require("../../assets/media/circle-ca.png");
const IR_flag = require("../../assets/media/circle-ir.png");

const amelia_png = require("../../assets/media/mocks/amelia.png");
const StageIcon = {
  "Test Roll Out": EcosystemTrialIcon,
  "Full Roll Out": EcosystemGoIcon,
  "Pro Roll Out": EcosystemProIcon,
};
class CampaignDeal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      brands: [],
      filter: "all",
      campaignManager: {
        value: "all",
        label: "All",
      },
      brandNameFilter: {
        value: "all",
        label: "All",
      },
      stageFilter: {
        value: "all",
        label: "All",
      },
      territoryFilter: {
        value: "all",
        label: "All",
      },
    };
  }

  componentDidMount() {
    const { role } = this.props.location.state;
    const umbrellaBrand = Number(localStorage.getItem("umbrella"));
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      if (role !== 0 && role !== 10) this.props.history.push("/");
    }

    Firebase.getAllBrands((res) => {
      let brands = res
        .map((item, index) => {
          let new_item = item;
          new_item.id = index;
          return new_item;
        })
        .filter(
          (item) =>
            item &&
            !item.deactive &&
            (item.salesStage === "Test Roll Out" ||
              item.salesStage === "Full Roll Out")
        );
      if (role === 10) {
        brands = brands.filter((obj) => obj.parent === umbrellaBrand);
      }
      this.setState({ isLoading: false, brands });
    });
  }

  getFlag = (territory) => {
    if (territory === "USA") return US_flag;
    else if (territory === "CANADA") return CA_flag;
    else if (territory === "IRELAND") return IR_flag;
  };
  filterBrands = () => {
    const {
      brands,
      stageFilter,
      territoryFilter,
      campaignManager,
      brandNameFilter,
    } = this.state;

    let filtered = [];
    if (stageFilter.value === "all") {
      filtered = [...brands];
    } else {
      filtered = brands.filter((item) => item.salesStage === stageFilter.value);
    }

    if (campaignManager.value !== "all") {
      filtered = filtered.filter(
        (item) => item.campaignManager === campaignManager.value
      );
    }

    if (brandNameFilter.value !== "all") {
      filtered = filtered.filter((item) =>
        item.name.toLowerCase().startsWith(brandNameFilter.value.toLowerCase())
      );
    }

    if (territoryFilter.value !== "all") {
      filtered = filtered.filter(
        (item) =>
          item.territory ===
          (territoryFilter.value === "UK" ? undefined : territoryFilter.value)
      );
    }
    return filtered;
  };

  addBrand = (brandName, brandUrl, logo_img, icon_img, hexcode, umbrella) => {
    const { role } = this.props.location.state;
    const umbrellaBrand = Number(localStorage.getItem("umbrella"));

    Firebase.addFiletoBrand(
      brandName,
      brandUrl,
      logo_img,
      icon_img,
      hexcode,
      umbrella,
      (res) => {
        console.log("image url", res);
        if (res !== "error") {
          Firebase.createDefaultBrandAdmin(res, brandName);

          if (role === 10 && umbrellaBrand) {
            Firebase.updateBrandDataById(res, { parent: umbrellaBrand });
          }
        }
      }
    );
  };

  goToBrandAdmin = (brand) => () => {
    this.props.history.push("/brand", {
      username: this.props.location.state.username,
      role: this.props.location.state.role,
      brand: brand.id,
    });
  };

  onFilterChanged = (filter) => {
    this.setState({
      filter,
    });
  };

  renderFilter = () => (
    <div className="filter_tab">
      <button
        className="btn channel-filter-btn"
        onClick={() => this.onFilterChanged("all")}
      >
        View All
      </button>
      <button
        className="btn channel-filter-btn"
        onClick={() => this.onFilterChanged("Test Roll Out")}
      >
        Test Roll Out
      </button>
      <button
        className="btn channel-filter-btn"
        onClick={() => this.onFilterChanged("Full Roll Out")}
      >
        Full Roll Out
      </button>
    </div>
  );

  showBrands = () => {
    const filteredBrands = this.filterBrands();
    filteredBrands.sort(function (a, b) {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    return filteredBrands
      .filter((item) => item.campaignManager)
      .map((item) => {
        const logo = item.logo;
        const brand = item.id;

        return (
          <div className="brand-item-container" key={item.id}>
            <Link
              to={{
                pathname: "/brand",
                state: {
                  brand: brand,
                  username: username,
                  role: role,
                },
              }}
              className="block block-rounded block-link-pop text-center"
            >
              <div className="logo-container">
                <img src={logo} alt="logo" />
              </div>
            </Link>
            <div className="row-value">
              <p style={{ marginBottom: 0 }}>{item.name}</p>
            </div>
            <div
              className="row-value"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <p style={{ marginBottom: 0, fontSize: 20 }}>
                {item.campaignManager}
              </p>
              <img
                src={amelia_png}
                alt="type"
                style={{
                  height: "40px",
                  marginLeft: 5,
                  objectFit: "contain",
                }}
              />
            </div>
            <div className="row-value">
              {item.territory ? (
                <img
                  src={this.getFlag(item.territory)}
                  alt="type"
                  style={{
                    height: "40px",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <img
                  src={UK_flag}
                  alt="type"
                  style={{
                    height: "40px",
                    objectFit: "contain",
                  }}
                />
              )}
            </div>
            <div className="row-value">
              {StageIcon[item.salesStage] ? (
                <img
                  src={StageIcon[item.salesStage]}
                  alt="type"
                  style={{
                    height: "40px",
                    objectFit: "contain",
                  }}
                />
              ) : (
                item.salesStage
              )}
            </div>
            <div className="row-value"></div>
          </div>
        );
      });
  };

  handleCampaignManagerChanged = (value) => {
    this.setState({
      campaignManager: value,
    });
  };

  handleBrandNameFilterChanged = (value) => {
    this.setState({
      brandNameFilter: value,
    });
  };

  handleStageFilterChanged = (value) => {
    this.setState({
      stageFilter: value,
    });
  };

  handleTerritoryFilterChanged = (value) => {
    this.setState({
      territoryFilter: value,
    });
  };
  render() {
    const {
      stageFilter,
      territoryFilter,
      campaignManager,
      brandNameFilter,
      isLoading,
    } = this.state;
    if (!this.props.location.state) return <Redirect to="/" />;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    return (
      <div id="page-container">
        <Header username={username} role={role} />
        <main id="main-container" className="campaign-deal-container">
          <div className="content">
            {!isLoading ? (
              <React.Fragment>
                <div className="add-brand-filter-container">
                  <div className="sales-filter-group">
                    <p className="group-label">Campaign Manager</p>
                    <div className="input-container">
                      <Select
                        value={campaignManager}
                        onChange={this.handleCampaignManagerChanged}
                        options={[
                          {
                            value: "all",
                            label: "All",
                          },
                          ...CampaignManagerOptions,
                        ]}
                      />
                    </div>
                  </div>
                  <div className="sales-filter-group name-filter">
                    <p className="group-label">Brand Name</p>
                    <div className="input-container">
                      <Select
                        value={brandNameFilter}
                        onChange={this.handleBrandNameFilterChanged}
                        options={[
                          {
                            value: "all",
                            label: "All",
                          },
                          ...Characters.map((item) => ({
                            value: item,
                            label: item,
                          })),
                        ]}
                      />
                    </div>
                  </div>
                  <div className="sales-filter-group">
                    <p className="group-label">Phase</p>
                    <div className="input-container">
                      <Select
                        value={stageFilter}
                        onChange={this.handleStageFilterChanged}
                        options={[
                          {
                            value: "all",
                            label: "All",
                          },
                          ...stageOptions,
                        ]}
                      />
                    </div>
                  </div>
                  <div className="sales-filter-group">
                    <p className="group-label">Territory</p>
                    <div className="input-container">
                      <Select
                        value={territoryFilter}
                        onChange={this.handleTerritoryFilterChanged}
                        options={[
                          {
                            value: "all",
                            label: "All",
                          },
                          ...TerritoryOptions,
                        ]}
                      />
                    </div>
                  </div>
                </div>
                <div className="brands-container">
                  <div className="brandchannel-header">
                    <div className="logo-header">Client</div>
                    <div className="header-item">Name</div>
                    <div className="header-item">Campaign Manager</div>
                    <div className="header-item">Territory</div>
                    <div className="header-item">Plan</div>
                    <div className="header-item"></div>
                  </div>
                  <div className="brand-items-container">
                    {this.showBrands()}
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            )}
          </div>
        </main>
      </div>
    );
  }
}
export default CampaignDeal;



// WEBPACK FOOTER //
// ./src/screens/CampaignDeal/index.js